import React from 'react';

import { addressFieldNames as fields } from '../address/addressModule';
import {
    defaultFieldProps,
    addressPropTypes
} from './addressFieldsModule';

import { fieldValidatorsNL } from './addressValidation';
import addressFields from './addressFieldMessages';
import netherlandsProvinceMap from './data/NLProvinceMap';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateSelectField,
    PostalCodeField
} from './Fields';
import postalCodeNormalizerNL from '../validate/postalCodeNormalizarNL';


export const makeProvinceList = (intl) => {
    const provinces = Object.keys(netherlandsProvinceMap);
    const placeholder = {
        value: '',
        label: intl.formatMessage(addressFields.NL.stateLabel)
    };
    return [placeholder].concat(provinces.map(code => ({
        value: code,
        label: intl.formatMessage(netherlandsProvinceMap[code])
    })));
};


export const AddressFieldsNL = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    useAddressAutocomplete,
    validators,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.DEFAULT.street1Label,
        updateShippingAddress,
        useAddressAutocomplete,
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.NL.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.DEFAULT.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        label: addressFields.NL.stateLabel,
        options: makeProvinceList(intl),
        validate: validators.get(fields.ADDRESS_STATE)
    };
    const postalCodeProps = {
        ...commonFieldProps,
        fieldType: 'tel',
        normalize: postalCodeNormalizerNL,
        label: addressFields.NL.postalCodeLabel,
        validate: validators.get(fields.ADDRESS_POSTCODE)
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateSelectField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsNL.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsNL
};

AddressFieldsNL.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsNL;
